export default {"src":"/_next/static/media/share-icon.39f4b846.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};